module.exports = __webpack_public_path__ + "static/media/twinkle-color-carousel-4.e11c9f05.png";